export class ActionPointsCampaignConfigurationResult {
    private _success : boolean;
    private _campaignSequence: number;
    private _message : string; 

    constructor(success, campaignSequence = undefined, message = '[Empty Message]'){
        this._success = success;
        this._campaignSequence = campaignSequence;
        this._message = message;
    }

    public isSuccess() : boolean {
        return this._success;
    }

    public getSequence() : number {
        return this._campaignSequence;
    }

    public getMessage() : string {
        return this._message;
    }
}